import type { HTMLComponent } from "@commercekit/react";
import classNames from "classnames";

const WvCartActionAlert: HTMLComponent<{
  message: string;
  closeAlert: Function;
}> = ({ message, closeAlert, className, ...props }) => (
  <div className={classNames("payment-method mb-3 p-2", className)} {...props}>
    <div className="d-flex justify-content-between align-items-center">
      <span>{message}</span>
      <span className="pointer fs-500 ml-2" onClick={() => closeAlert()}>
        &times;
      </span>
    </div>
  </div>
);
export default WvCartActionAlert;
